<div class="section-plain-text">
    <div class="wide-content-wrapper-cnt">
        <div class="section-plain-text__inner">
            <div class="section-plain-text__description" v-html="description"></div>
        </div>
    </div>
</div>